module.exports = __webpack_public_path__ + "static/media/nep-stat-logo.cced5c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nep-stat-logo.png
// module id = 246
// module chunks = 12